import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pay-unchecked",
  "use": "icon-pay-unchecked-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-pay-unchecked\"><defs><style>#icon-pay-unchecked .a,#icon-pay-unchecked .c{fill:none;}#icon-pay-unchecked .a{stroke:#e8e9eb;stroke-width:1.5px;}#icon-pay-unchecked .b{stroke:none;}</style></defs><g class=\"a\"><circle class=\"b\" cx=\"10\" cy=\"10\" r=\"10\" /><circle class=\"c\" cx=\"10\" cy=\"10\" r=\"9.25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pay-unchecked.svg
// module id = 61Kq
// module chunks = 64